import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/soirees-thematiques")({
  component: () => <Outlet />,
});
